import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-4">
            SEO Guides
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-[1.15] mb-4">
            Latest Pandabuy <span className="italic">Spreadsheet</span> Articles
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
            Expert guides, shopping tips, and curated finds — everything you need to master pandabuy spreadsheets.
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-100 rounded-2xl overflow-hidden border-2 border-background-200/60 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full h-44 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400">&middot;</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-lg text-foreground-950 mb-2 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-0.5 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Link to all guides */}
        <div className="text-center mt-10">
          <Link
            to="/pandabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 border border-background-300 rounded-full text-sm font-semibold text-foreground-900 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer whitespace-nowrap"
          >
            Read Complete Buying Guide
            <i className="ri-arrow-right-up-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}